<template>
  <div class="body-wrapper">
    <h5 class="title">
      {{ questionData?.name }}
    </h5>
    <p class="paragraph">{{questionData.description}}</p>

    <div class="card-wrapper">
      <img :src="getImageUrl()" />
    </div>
  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";

export default{
  components: {QuestionImage},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  },
  methods: {
    getImageUrl() {
      return this.questionData.content?.attach[0]?.file?.attachUrl || '';
    }
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  height: 100%;
  padding: 10px;
  z-index: 1;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.card-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
}

.card-wrapper img {
  width: 100%;
  height: 100%;
  border-radius: 18px;
  object-fit: cover;
}
.paragraph {
  font-size: 14px;
  color: #475467;
  margin: 0;
  padding: 0;
  font-family: euclid_regular, sans-serif;
}
</style>
